import styled from 'styled-components';
import {dFlexCenter} from '../../../../../globalVariables/GlobalVariables';

export const trigger = styled.button`
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    border: none;
    padding: 0;
    background: transparent;
    cursor: pointer;
    ${dFlexCenter}
    opacity: 0.6;
    &:hover {
        opacity: 1;
    }
`;
